import './style/index.js';

import _Tooltip from './tooltip';

export type { TooltipProps } from './tooltip';
export * from './type';

export const Tooltip = _Tooltip;
export default Tooltip;
